import { Link } from "react-router-dom";

export const Logo = ({ variant = "full", className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="logo-link"
      className={`group inline-flex items-center gap-3 ${className}`}
    >
      <span
        className="relative flex h-11 w-11 items-center justify-center border border-[#D4AF37]/60 bg-[#0A1128] transition-all group-hover:border-[#D4AF37] group-hover:shadow-[0_0_18px_rgba(212,175,55,0.25)]"
        aria-hidden
      >
        <svg
          viewBox="0 0 40 40"
          className="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="llu-gold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#F3E5AB" />
              <stop offset="55%" stopColor="#D4AF37" />
              <stop offset="100%" stopColor="#A17F1A" />
            </linearGradient>
          </defs>
          {/* Monogram L L U */}
          <path
            d="M6 7 V28 H14"
            stroke="url(#llu-gold)"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="square"
          />
          <path
            d="M16 7 V28 H24"
            stroke="url(#llu-gold)"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="square"
          />
          <path
            d="M26 7 V22 Q26 28 32 28 Q34 28 34 28 V7"
            stroke="url(#llu-gold)"
            strokeWidth="2.4"
            fill="none"
            strokeLinecap="square"
          />
          {/* Base rule */}
          <path
            d="M5 33 H35"
            stroke="url(#llu-gold)"
            strokeWidth="1.2"
            fill="none"
          />
        </svg>
        <span className="absolute -bottom-[1px] left-1/2 h-[2px] w-7 -translate-x-1/2 bg-[#D4AF37]" />
      </span>
      {variant === "full" && (
        <span className="flex flex-col leading-none">
          <span className="font-serif text-lg tracking-[0.18em] text-white whitespace-nowrap">
            LENDING LOAN
          </span>
          <span className="mt-1 font-sans text-[10px] tracking-[0.42em] text-[#D4AF37]">
            U · S · A
          </span>
        </span>
      )}
    </Link>
  );
};

export default Logo;
